import { Component, Prop, Vue } from 'vue-property-decorator'
import { i18n } from "@/i18n"

/**
 * Background styles mixin
 */
@Component
export default class extends Vue {
  @Prop({ type: String })
  backgroundColor?: string

  @Prop({ type: String })
  backgroundImage?: string

  @Prop({ type: String, default: "center" })
  backgroundPosition!: string

  @Prop({ type: String, default: "no-repeat" })
  backgroundRepeat!: string

  // contain | cover | auto | <length> | <percentage>
  @Prop({ type: String, default: "cover" })
  backgroundSize!: string

  get computedBackgroundUrl () {
    const { backgroundImage } = this
    return backgroundImage ? `url(${i18n.t(backgroundImage)})` : undefined
  }

  get computedBackgroundStyles () {
    const {
      backgroundColor,
      backgroundPosition,
      backgroundRepeat,
      backgroundSize,
      computedBackgroundUrl
    } = this
    return {
      backgroundColor,
      backgroundImage: computedBackgroundUrl,
      backgroundPosition,
      backgroundRepeat,
      backgroundSize
    }
  }
}
